import {Component} from '@angular/core';
import {ActionSheetController} from '@ionic/angular';
import {Router} from '@angular/router';
import {MitekService} from '../../services/mitek/mitek.service';

@Component({
  selector: 'app-seleccionar-doc',
  templateUrl: './seleccionar-doc.page.html',
  styleUrls: ['./seleccionar-doc.page.scss'],
})
export class SeleccionarDocPage {

  constructor(public actionSheetController: ActionSheetController, private router: Router ,private mitekService: MitekService) {

    this.mitekService.$MitekServiceState.unsubscribe();
    this.presentActionSheet().then();
  }

  async presentActionSheet() {
    const actionSheet = await this.actionSheetController.create({
      mode: 'ios',
      header: 'Seleccionar identificación',
      cssClass: 'my-custom-class',
      buttons: [{
        text: 'INE',
        handler: () => {

          this.continueNextPage('Identificación INE');
        }
      }, {
        text: 'Cédula Profesional',
        handler: () => {

          this.continueNextPage('Cedula Profesional');

        }
      }, {
        text: 'Pasaporte Mexicano',
        handler: () => {

          this.continueNextPage('Pasaporte Mexicano');

        }
      }, {
        text: 'Forma Migratoria',
        handler: () => {

          this.continueNextPage('Forma Migratoria');
        }
      }
        , {
          text: 'Cancelar',
          icon: 'close',
          role: 'cancel',
          handler: () => {
            this.presentActionSheet();
          }
        }]
    });
    await actionSheet.present();
  }

  continueNextPage(type): void {
    this.router.navigate(['/dashboard/ine', {type}]);
  }

}
